import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { IAdminEquipmentGroup, TSortAdminEquipmentGroupByHeaderTitle } from 'types';
import { AdminListCheckbox } from '../AdminListCheckbox';
import { AdminListHeaderCell } from '../AdminListHeaderCell';
import { StyledAdminEquipmentGroupsListHeader } from './styles';
import { AdminFilterSelect } from '../AdminFilterSelect';

interface IEquipmentGroupsListHeaderProps {
  children?: React.ReactNode;
  onSelectAll: (selected: boolean) => void;
  selectedAll?: boolean;
  onSort: (sort: TSortAdminEquipmentGroupByHeaderTitle) => void;
  sortBy: string | null;
  sortDir: 'ASC' | 'DESC' | 'NONE';
  onFilter: (filterByValue: { filterBy: keyof IAdminEquipmentGroup; filterValue: string }) => void;
}

type FieldType = {
  key: TSortAdminEquipmentGroupByHeaderTitle;
  sortable?: boolean;
  filterable?: boolean;
};

export const headerFields: FieldType[] = [
  { key: 'equipmentId', sortable: true },
  { key: 'link' },
  { key: 'stringDeviceGroupName', sortable: true },
  { key: 'currentDeviceGroupName', sortable: true },
  { key: 'testHashrate', filterable: true },
  { key: 'hashRate1hour', filterable: true },
  { key: 'hashRate24h', filterable: true },
  { key: 'hashrateWeekly', filterable: true },
];

export const AdminEquipmentGroupsListHeader = ({
  onSort,
  onSelectAll,
  onFilter,
  selectedAll,
  sortBy,
  sortDir,
}: IEquipmentGroupsListHeaderProps) => {
  const { t } = useTranslation();

  const selectRowHandler = () => {
    onSelectAll(!selectedAll);
  };

  return (
    <StyledAdminEquipmentGroupsListHeader>
      <div className="admin-list-header-cell-container select">
        <AdminListCheckbox checked={selectedAll} onChange={selectRowHandler} />
      </div>
      {headerFields.map(({ key, sortable, filterable }) => (
        <div key={key} className={cn('admin-list-header-cell-container', key.toLowerCase())}>
          <AdminListHeaderCell
            fieldKey={key}
            filter={filterable}
            sort={sortable}
            onSort={sortable ? () => onSort(key) : undefined}
            onFilter={
              filterable
                ? () => (
                    <AdminFilterSelect
                      onSelect={(value) => onFilter({ filterBy: key, filterValue: value })}
                      filterName={key}
                      optionsList={[
                        '0',
                        '<1000',
                        '>1000<3000',
                        '>3000<10000',
                        '>10000<30000',
                        '>30000<100000',
                      ]}
                    />
                  )
                : undefined
            }
            isActive={sortBy === key}
            sortDir={sortBy === key ? sortDir : 'NONE'}
          >
            {t(`adminPage.editEquipmentGroups.listHeaders.${key}`)}
          </AdminListHeaderCell>
        </div>
      ))}
    </StyledAdminEquipmentGroupsListHeader>
  );
};
